import { render, staticRenderFns } from "./Selesai.vue?vue&type=template&id=2f6b0191&"
import script from "./Selesai.vue?vue&type=script&lang=js&"
export * from "./Selesai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports